import React from "react";
import { useTranslation } from "react-i18next";
import { archiveSheet } from "../actions";
import { ActionMenu, ModalBuilder, Table } from "@redriver/cinnamon";
import { withRouter } from "react-router-dom";
import {
  withCurrentUser,
  PermissionCheck,
} from "features/../../../shared/components/auth";

import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import { TranslatedModal } from "features/../../../shared/components/modals";
import { DropdownItem } from "semantic-ui-react";
import { ImpersonatedUserPermissionCheck } from "modules/ImpersonatedUserPermissions";

const ArchiveSheet = ({ sheet, onSubmitted }) => {
  const { t } = useTranslation("agreements");
  const { sheetId, sheetName } = sheet;

  return (
    <ImpersonatedUserPermissionCheck
      target={Targets.Sheet}
      action={Actions.ArchiveAndUnarchiveSheets}
    >
      <ModalBuilder
        withForm
        submitAction={archiveSheet}
        submitParams={sheetId}
        onSubmitted={onSubmitted}
        renderTrigger={(trigger) => (
          <DropdownItem onClick={trigger}>
            {t("SheetActions.ArchiveSheet.TriggerText")}
          </DropdownItem>
        )}
        renderModal={(modalProps) => (
          <TranslatedModal.Confirmation
            {...modalProps}
            header={t("SheetActions.ArchiveSheet.HeaderText")}
            size="small"
          >
            {t("SheetActions.ArchiveSheet.ConfirmMessage", { sheetName })}
          </TranslatedModal.Confirmation>
        )}
      />
    </ImpersonatedUserPermissionCheck>
  );
};

export default withCurrentUser(withRouter(ArchiveSheet));
